import Stack from "@mui/material/Stack";
import { RichTextEditor } from "@src/components/RichTextEditor";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { InputProps } from "./types";

export const RichTextInput = ({ label, value, onChange }: InputProps) => (
  <Stack spacing={1}>
    <Panel.Header>{label}</Panel.Header>
    <RichTextEditor
      value={value}
      onChange={onChange}
      disabled={false}
      minHeight="4em"
    />
  </Stack>
);
